import { useCallback, useMemo, type ReactNode } from "react";

import { getSteppedZoom, ZOOM_STEPS } from "@skilitics/designer-ui-components";

import { ZoomContext, type ZoomStep } from "./ZoomContext";

const zoomSteps: ZoomStep[] = ZOOM_STEPS.map((scale) => ({ name: `${scale * 100}%`, scale }));

type Props = {
  scale: number;
  onZoomChange: (zoom: number) => void;
  children: ReactNode;
};

export const ZoomProvider = ({ scale, onZoomChange, children }: Props) => {
  const handleZoomIn = useCallback(() => onZoomChange(getSteppedZoom(1, scale)), [onZoomChange, scale]);

  const handleZoomOut = useCallback(() => onZoomChange(getSteppedZoom(-1, scale)), [onZoomChange, scale]);

  const value = useMemo(
    () => ({
      zoom: scale,
      zoomSteps,
      onZoomIn: handleZoomIn,
      onZoomOut: handleZoomOut,
      onChangeZoom: onZoomChange,
    }),
    [handleZoomIn, handleZoomOut, onZoomChange, scale],
  );

  return <ZoomContext.Provider value={value}>{children}</ZoomContext.Provider>;
};
